import {resources} from "../../../../../../../core/models/resource/resources";

export const technicalConclusionResourceType = resources['technical-conclusions'];
export const technicalConclusionFilesResourceType = resources['technical-conclusion-files'];
